import { Card, CardContent, Typography, Grid } from '@mui/material';
import { Fragment } from 'react';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';

function Home() {
    return (
        <Fragment>
            <TituloPagina>eSocial - Módulo Relatórios</TituloPagina>

            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardContent>
                            <Typography style={{ fontSize: '0.875rem' }} color="textSecondary" align="justify" gutterBottom>
                                O eSocial é um sistema informatizado da Administração Pública e todas as informações nele contidas estão protegidas por sigilo. O acesso não autorizado, a disponibilização voluntária ou acidental da senha de acesso ou de informações e a quebra do sigilo constituem infrações ou ilícitos que sujeitam o usuário a responsabilidade administrativa, penal e civil.
                            </Typography>

                            <Typography style={{ fontSize: '0.875rem' }} color="textSecondary" align="justify" gutterBottom>
                                O usuário declara-se ciente das responsabilidades acima referidas ao acessar qualquer sistema no sítio eletrônico do eSocial.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Fragment>
    );
}

export default Home;
